import { Table } from '@mantine/core';
import { useSelector } from 'react-redux';
import formatDate from '../../constants/formattedDate';
import { getUserIdFromProfileId } from '../../helpers/profileId';
import AvatarInitials from '../AvatarInitials';

const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const ProfileRows = ({ profiles }) => {
  const { domain } = useSelector((state) => state.domain);

  return profiles.map((profile, index) => (
    <Table.Tr key={index}>
      <Table.Td>
        <div style={{ display: 'inline-block', verticalAlign: 'middle', margin: 0 }}>
          <AvatarInitials user={profile} />
        </div>
        &nbsp;&nbsp;
        <a
          href={`#/accounts/${domain.accountId}/domains/${domain.id}/profiles/${encodeURIComponent(
            profile.profileId
          )}/events`}
          data-tour={index === 0 ? 'profilesPageFirstProfileLink' : undefined}
        >
          <strong>
            {profile.firstName || profile.lastName
              ? capitalize(profile.firstName) + ' ' + capitalize(profile.lastName)
              : getUserIdFromProfileId(profile.profileId)}
          </strong>
        </a>
      </Table.Td>
      <Table.Td>{profile.email}</Table.Td>
      <Table.Td>{profile.phoneNumber}</Table.Td>
      <Table.Td>{formatDate(profile?.registeredAt)}</Table.Td>
      <Table.Td>{formatDate(profile?.subscribedAt)}</Table.Td>
      <Table.Td>{formatDate(profile?.timestamp)}</Table.Td>
    </Table.Tr>
  ));
};

export default ProfileRows;
